import {
    SET_RESULT, INCREMENT_INCORRECT_QUESTIONS_COUNTER, RESET_INCORRECT_QUESTIONS_COUNTER,
    CLEAR_RESULT,
    SET_LC_RESULT,
} from './resultActions';
import { RESULTS_FETCH_COMPLETED, RESULTS_FETCH_RESET } from './resultStudentActions';
import { UNMOUNT_SCREEN } from '../screen/screenActions';

export const defaultState = {
    byId: {},
    isDataFetched: false,
    incorrectQuestionsCounter: 0,
};

const getResultSummary = (result) => ({
    id: result.result_id,
    isComplete: result.is_complete,
    formId: result.form_id,
    measure: result.measure,
    measureType: result.measure_type,
    assessment: result.assessment,
});

const resultReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SET_LC_RESULT:
    case SET_RESULT: {
        return {
            ...state,
            byId: {
                ...state.byId,
                [action.result.result_id]: getResultSummary(action.result),
            },
        };
    }
    /* eslint-disable no-unused-vars */
    case CLEAR_RESULT: {
        const { [action.resultId]: deletedProperty, ...newState } = state.byId;
        return {
            ...state,
            byId: newState,
        };
    }
    /* eslint-enable no-unused-vars */
    case RESULTS_FETCH_COMPLETED:
        return {
            ...state,
            isDataFetched: true,
        };
    case RESULTS_FETCH_RESET:
        return {
            ...state,
            isDataFetched: false,
        };
    case INCREMENT_INCORRECT_QUESTIONS_COUNTER:
        return {
            ...state,
            incorrectQuestionsCounter: state.incorrectQuestionsCounter + 1,
        };
    case RESET_INCORRECT_QUESTIONS_COUNTER:
    case UNMOUNT_SCREEN:
        return {
            ...state,
            incorrectQuestionsCounter: 0,
        };
    default:
        return state;
    }
};

export default resultReducer;
